import Wrapper from "../../../layout/Wrapper";
import SpecialAgentCommisionManageComponent from "../../../screens/settings/special-agent-commission/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Special Agent Commision",
	description: "",
};

export default function SpecialAgentCommisionManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<SpecialAgentCommisionManageComponent />
		</Wrapper>
	);
}